import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function NavbarBottom() {
  //const [isOpen, setIsOpen] = useState(false);

  const user_token  = localStorage.getItem("token");
  const user_logine = localStorage.getItem("user_loginset");
  const getLang = localStorage.getItem('lang_code');
  //const [validation, setValidation] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [results, setResults] = useState([]);
  const [resultsb, setResultsb] = useState([]);
  const navigate = useNavigate();

  const searchHandler = async (e) => {
    e.preventDefault();

    if (!keyword) return;
      try {
        const response = await fetch(`https://dev.jftheskinspecialist.com/api/search?q=${keyword}`);
        const datas = await response.json();
        setResults(datas.data); // 

        const responseb = await fetch(`https://dev.jftheskinspecialist.com/api/searchb?q=${keyword}`);
        const datasb = await responseb.json();
        setResultsb(datasb.data); 

        navigate('/searchpage', { state: { prod: results, artikel: resultsb }});
      } catch (error) {
        console.error('Error fetching data:', error);
      }
  };

    return (
      <nav class="flex justify-between text-white w-screen sticky top-0 z-30" style={{ backgroundColor: '#fcf392' }}>
        <div class="px-5 xl:px-12 py-4 flex w-full items-center">
          {user_token ? 
            <Link class="font-bold font-heading hidden lg:block" to="/dashboard">
              <article class="text-wrap" style={{ color: '#fd9400', fontFamily: 'MuseoSansRounded900', fontSize: 20 }}>
                Hai, {user_logine}!
              </article>
            </Link>
            :
            <Link class="font-bold font-heading hidden lg:block" to="/login">
              <article class="text-wrap" style={{ color: '#fd9400', fontFamily: 'MuseoSansRounded900', fontSize: 20 }}>
                LOGIN
              </article>
            </Link>
          }
          
         <ul class="hidden md:flex px-4 mx-auto font-semibold font-heading space-x-12 pb-2" style={{ color: '#fd9400', fontFamily: 'MuseoSansRounded900', listStyleType: 'none', fontSize: 20 }}>
            <li><Link to="/home">{getLang ==='id' ? 'BERANDA' : 'HOME' }</Link></li>
            <li><Link to="/allproduct">{getLang ==='id' ? 'PRODUK' : 'PRODUCTS'}</Link></li>
            <li><Link to="/wheretobuy">{getLang === 'id' ? 'BELI DI SINI' : 'WHERE TO BUY'}</Link></li>
            <li><Link to="/blog">{getLang ==='id' ? 'BERITA & INFO' : 'BLOG & EVENT'}</Link></li>
          </ul>
          <div class="hidden lg:block" style={{ width: 230 }}>
            <div class="flex rounded-full border-2 border-[#fba82a] overflow-hidden mx-auto font-[MuseoSansRounded900]">
              <form onKeyUp={searchHandler}>
              <input type="text" placeholder={getLang === 'id' ? "Apa yang kamu cari ...?" : "What are you looking for..."}
                  class="w-full outline-none bg-white text-sm px-2 py-1 placeholder-[#fcc990]" value={keyword} onChange={(e) => setKeyword(e.target.value)} onKeyPress={e => {
                    if (e.key === 'Enter') e.preventDefault();
                  }} style={{ color: '#fd9400' }} />
              </form>
              <button class="flex items-center justify-center bg-[#fff] hover:bg-[#fff] px-4">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192.904 192.904" width="22px" class="fill-[#fba82a]">
                  <path
                    d="m190.707 180.101-47.078-47.077c11.702-14.072 18.752-32.142 18.752-51.831C162.381 36.423 125.959 0 81.191 0 36.422 0 0 36.423 0 81.193c0 44.767 36.422 81.187 81.191 81.187 19.688 0 37.759-7.049 51.831-18.751l47.079 47.078a7.474 7.474 0 0 0 5.303 2.197 7.498 7.498 0 0 0 5.303-12.803zM15 81.193C15 44.694 44.693 15 81.191 15c36.497 0 66.189 29.694 66.189 66.193 0 36.496-29.692 66.187-66.189 66.187C44.693 147.38 15 117.689 15 81.193z">
                  </path>
                </svg>
              </button>
            </div>
          </div>

          <div class="sm:hidden mx-auto text-center">
	    <div class="flex rounded-full border-2 border-[#fba82a] overflow-hidden mx-auto font-[MuseoSansRounded900]">
              <form onKeyUp={searchHandler}>
              <input type="text" placeholder={getLang === 'id' ? "Apa yang kamu cari ...?" : "What are you looking for..."}
                  class="w-full outline-none bg-white text-sm px-2 py-1 placeholder-[#fcc990]" value={keyword} onChange={(e) => setKeyword(e.target.value)} onKeyPress={e => {
                    if (e.key === 'Enter') e.preventDefault();
                  }} style={{ color: '#fd9400' }} />
              </form>
              <button class="flex items-center justify-center bg-[#fff] hover:bg-[#fff] px-4">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192.904 192.904" width="22px" class="fill-[#fba82a]">
                  <path
                    d="m190.707 180.101-47.078-47.077c11.702-14.072 18.752-32.142 18.752-51.831C162.381 36.423 125.959 0 81.191 0 36.422 0 0 36.423 0 81.193c0 44.767 36.422 81.187 81.191 81.187 19.688 0 37.759-7.049 51.831-18.751l47.079 47.078a7.474 7.474 0 0 0 5.303 2.197 7.498 7.498 0 0 0 5.303-12.803zM15 81.193C15 44.694 44.693 15 81.191 15c36.497 0 66.189 29.694 66.189 66.193 0 36.496-29.692 66.187-66.189 66.187C44.693 147.38 15 117.689 15 81.193z">
                  </path>
                </svg>
              </button>
            </div>

          </div>
          
        </div>
    </nav>);
}

export default NavbarBottom;